module.exports = __webpack_public_path__ + "static/media/omorose.93e74afa.pdf";